<template>
  <div>
    <van-tabs type="card" v-if="false">
      <van-tab title="全部" name="0"></van-tab>
      <van-tab
        :title="item.SSLXMC"
        v-for="(item, index) in sslxList"
        :key="index"
      ></van-tab>
    </van-tabs>

    <div style="margin-top:15px;">
      <van-collapse
        v-model="activeNames"
        v-for="(item, index) in resultXmList"
        :key="index"
      >
        <van-collapse-item :name="item.XMJC">
          <template #title>
            <div style="float:left">
              {{ item.XMJC }}
              <van-tag
                :type="item.ISBM === '1' ? 'success' : 'danger'"
                v-if="isLd !== '1' || reportLx === 'LDBM'"
                >{{ item.ISBM === "1" ? "已报名" : "未报名" }}</van-tag
              >
            </div>
            <div
              style="float:right"
              v-if="
                item.DATALIST.length > 0 ? item.DATALIST[0].ISSF === '1' : false
              "
            ></div>
          </template>
          <van-cell
            v-for="(mxItem, mxIndex) in item.DATALIST"
            :key="mxIndex"
            :value="
              ISBMRCOUNT !== '1'
                ? ''
                : mxItem.SSLX.substr(1, 2) === 'T' && reportLx === 'DYBM'
                ? ''
                : bmLx === 'TEAM'
                ? '已报' +
                  mxItem.YBMRS +
                  ' ' +
                  (mxItem.SSLX.substr(1, 2) === 'D'
                    ? '对'
                    : mxItem.SSLX.substr(1, 2) === 'T'
                    ? '队'
                    : '人') +
                  ' / ' +
                  (mxItem.BMRSXZ.length === 0 ||
                  mxItem.BMRSXZ === -1 ||
                  mxItem.BMRSXZ > 999
                    ? '无限制'
                    : '剩余' +
                      (mxItem.BMRSXZ - mxItem.YBMRS) +
                      (mxItem.SSLX.substr(1, 2) === 'D'
                        ? '对'
                        : mxItem.SSLX.substr(1, 2) === 'T'
                        ? '队'
                        : '人'))
                : mxItem.YBMRS +
                  ' ' +
                  (mxItem.SSLX.substr(1, 2) === 'D'
                    ? '对'
                    : mxItem.SSLX.substr(1, 2) === 'T'
                    ? '队'
                    : '人') +
                  ' / ' +
                  (mxItem.BMRSXZ.length === 0 ||
                  mxItem.BMRSXZ === -1 ||
                  mxItem.BMRSXZ > 999
                    ? '无限制'
                    : '限' +
                      mxItem.BMRSXZ +
                      (mxItem.SSLX.substr(1, 2) === 'D'
                        ? '对'
                        : mxItem.SSLX.substr(1, 2) === 'T'
                        ? '队'
                        : '人'))
            "
            is-link
            @click="navRmbmUrl(mxItem, mxItem.ITEMISBM)"
          >
            <template #title>
              <span class="custom-title">
                <span
                  v-if="
                    ssid !==
                      '69736c3638616f7575746b79664f736b334f425763314a66314841587771497a'
                  "
                >
                  {{
                    mxItem.SSLX === "MS" ||
                    mxItem.SSLX === "WS" ||
                    mxItem.SSLX === "XS"
                      ? mxItem.ISXB === "Y"
                        ? mxItem.SSLXMC
                        : "单打"
                      : mxItem.SSLX === "MD" ||
                        mxItem.SSLX === "WD" ||
                        mxItem.SSLX === "XD" ||
                        mxItem.SSLX === "SD"
                      ? mxItem.ISXB === "Y"
                        ? mxItem.SSLXMC
                        : "双打"
                      : mxItem.SSLXMC
                  }}
                </span>
                <span
                  v-if="
                    ssid ===
                      '69736c3638616f7575746b79664f736b334f425763314a66314841587771497a'
                  "
                >
                  {{ mxItem.SSLX.substr(0, 1) === "M" ? "男子" : "女子" }}
                </span>
              </span>
              <van-tag
                :type="mxItem.ITEMISBM === '1' ? 'success' : 'danger'"
                v-if="isLd !== '1' || reportLx === 'LDBM'"
                >{{ mxItem.ITEMISBM === "1" ? "已报名" : "未报名" }}</van-tag
              >
              <van-tag
                type="success"
                v-if="mxItem.ISSF === '1' && mxItem.SSLX.substr(1, 2) !== 'T'"
                >{{
                  mxItem.SFJE - 0 > 0 ? mxItem.SFJE + "元" : "多标准"
                }}</van-tag
              >
              <van-tag
                type="warning"
                v-if="
                  mxItem.ISHYMF === '1' &&
                    mxItem.SSLX.substr(1, 2) !== 'T' &&
                    reportLx !== 'DYBM'
                "
              >
                会员优惠
              </van-tag>
            </template>
          </van-cell>
        </van-collapse-item>
      </van-collapse>
    </div>
  </div>
</template>

<script>
import { Dialog } from "vant";
export default {
  props: {
    ssid: {
      //赛事ID
      type: String,
      default: ""
    },
    resultXmList: {
      type: Array,
      default: null
    },
    sslxList: {
      type: Array,
      default: null
    },
    utilPost: {
      type: Object,
      default: null
    },
    bmLx: {
      type: String,
      default: ""
    },
    dwid: {
      type: String,
      default: ""
    },
    czlx: "",
    reportLx: {
      //是否直接对团体项目报名，用于领队报名团体赛
      // LDBM：领队报名 主要用于区分团体  GRDWBM：纯个人队伍报名  DYBM：队员报名，有队伍的情况下 CJMDBM：通过采集名单的方式报名
      type: String,
      default: ""
    },
    isLd: {
      //是否为领队
      type: String,
      default: ""
    },
    ISBMRCOUNT: {
      type: String,
      default: ""
    },
    checkBmrsLx: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      activeNames: []
    };
  },
  created() {},
  methods: {
    navRmbmUrl(mxItem, ISBM) {
      if (this.reportLx === "CJMDBM" && this.bmLx !== "GR") {
        this.$router.push({
          path: "/teamSelectCy",
          query: {
            ssid: this.ssid,
            xmid: mxItem.XMID,
            bmLx: "TEAM",
            dwid: this.dwid,
            czlx: this.czlx
          }
        });
        return;
      }

      var busData = {
        XMID: mxItem.XMID,
        checkBmrsLx: this.checkBmrsLx
      };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: "wapGL", //反射名称
          methodName: "checkBmrs" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        //alert(JSON.stringify(data));
        if (!data.isSuccess) {
          this.$notify({
            type: "danger",
            message: data.msg,
            duration: 6000
          });
          return;
        }
        if (this.bmLx === "GR") {
          this.$router.push({
            path: "/addRyInfo",
            query: {
              ssid: this.ssid,
              xmid: mxItem.XMID,
              bmLx: "GR",
              dwid: "",
              czlx: this.czlx
            }
          });
          // if (ISBM === "1") {
          //   this.$router.push({
          //     path: "/grBmDataIndex",
          //     query: {
          //       ssid: this.ssid,
          //       xmid: mxItem.XMID,
          //       bmLx: "GR",
          //       dwid: "",
          //       czlx: this.czlx
          //     }
          //   });
          // } else {
          //   this.$router.push({
          //     path: "/addRyInfo",
          //     query: {
          //       ssid: this.ssid,
          //       xmid: mxItem.XMID,
          //       bmLx: "GR",
          //       dwid: "",
          //       czlx: this.czlx
          //     }
          //   });
          // }
        } else {
          //如果通过采集名单的方式报名  则跟老版本是一样的
          if (this.reportLx === "CJMDBM") {
            this.$router.push({
              path: "/teamSelectCy",
              query: {
                ssid: this.ssid,
                xmid: mxItem.XMID,
                bmLx: "TEAM",
                dwid: this.dwid,
                czlx: this.czlx
              }
            });
          } else if (this.reportLx === "LDBM") {
            //直接报名队伍，只能用于团体赛
            Dialog.confirm({
              title: "提示",
              message: "是否提交报名？"
            })
              .then(() => {
                var busData = {
                  DWID: this.dwid,
                  XMID: mxItem.XMID
                };
                var paramData = {
                  headerData: {
                    ssid: this.ssid,
                    op: "wapGL", //反射名称
                    methodName: "ldbmDw" //对应的方法名
                  },
                  busData: busData //参数内容
                };
                this.utilPost.paramData = paramData;
                this.utilPost.sendPost().then(data => {
                  this.$notify({
                    type: "success",
                    message: data.msg,
                    duration: 6000
                  });
                  if (data.isSuccess) {
                    var XMNM = data.content.XMNM;
                    var XMID = data.content.XMID;
                    var ISSF = data.content.ISSF;
                    if (ISSF === "1") {
                      Dialog.alert({
                        title: "报名成功",
                        message:
                          "请您在3个小时内完成缴费，超时未交费系统将会清除您的报名信息，请悉知"
                      }).then(() => {
                        this.$router.push({
                          path: "/alreadyBmxx",
                          query: {
                            ssid: this.ssid,
                            requestXmnm: XMNM,
                            requestXmid: XMID,
                            czlx: "ADD"
                          }
                        });
                      });
                    } else {
                      this.$router.push({
                        path: "/alreadyBmxx",
                        query: {
                          ssid: this.ssid,
                          requestXmnm: XMNM,
                          requestXmid: XMID,
                          czlx: "ADD"
                        }
                      });
                    }
                  }
                });
              })
              .catch(() => {
                // on cancel
              });
          } else if (this.reportLx === "DYBM") {
            //队员报名  直接按个人报名走，只不过需要指定对应的队伍ID
            if (this.dwid === "") {
              this.$notify({
                type: "danger",
                message: "队伍ID不能为空",
                duration: 6000
              });
              return;
            }
            if (mxItem.SSLX.substr(1, 2) === "T") {
              this.$router.push({
                path: "/addRyInfo",
                query: {
                  ssid: this.ssid,
                  xmid: mxItem.XMID,
                  bmLx: "TEAM",
                  dwid: this.dwid,
                  czlx: this.czlx,
                  ryid1Param: "",
                  ryid2Param: "",
                  checkBmrsLx: this.checkBmrsLx
                }
              });
            } else {
              this.$router.push({
                path: "/addRyInfo",
                query: {
                  ssid: this.ssid,
                  xmid: mxItem.XMID,
                  bmLx: "GR",
                  dwid: this.dwid,
                  czlx: this.czlx
                }
              });
            }
          } else {
            alert("类型不存在");
          }
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.van-tabs__nav--card {
  border: 1px solid #1a4168 !important;
}
.van-tabs__nav--card .van-tab.van-tab--active {
  background-color: #1a4168 !important;
}
.van-tabs__nav--card .van-tab {
  border-right: 1px solid #1a4168 !important;
}
.van-tabs__nav--card .van-tab {
  color: #1a4168 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/commonCom/ChangeXm.vue